import { useEffect } from "react";

import { getPrimaryToastProps } from "@/assignments/utils/assignmentToastHelpers";
import { getLocalISOStringDate } from "@/assignments/utils/dateUtils";
import globalToasterRef from "@/base/globalToasterRef";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const useExpirationWarning = (content = {}) => {
  const { data: user } = useUser();
  const { isStudent, isLiteUser } = getUserProperties(user);
  const { date_lite_product_grant_expires: expirationDate } = content;

  // Show relevant warnings if applicable:
  useEffect(() => {
    if (expirationDate && isLiteUser && !isStudent) {
      const formattedExpDate = getLocalISOStringDate(
        expirationDate,
        "MM/DD/YYYY",
      );
      const expirationToastProps = getPrimaryToastProps(
        `This article expires on ${formattedExpDate}. Check that students have enough time to finish.`,
      );
      globalToasterRef.current.displayToast(expirationToastProps);
    }
  }, [expirationDate, isLiteUser, isStudent]);
};

export default useExpirationWarning;
